import { render, staticRenderFns } from "./type-grid.vue?vue&type=template&id=abf807bc&scoped=true&"
import script from "./type-grid.vue?vue&type=script&lang=js&"
export * from "./type-grid.vue?vue&type=script&lang=js&"
import style0 from "./type-grid.vue?vue&type=style&index=0&id=abf807bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf807bc",
  null
  
)

export default component.exports